import CapacityCustomContent from "../../CapaciteCustom/CapacityCustomContent";
import { ConfigurationPageType } from "../interfaces";

export const SETUP_CAPACITE_CUSTOM_PAGE = {
  type: ConfigurationPageType.CUSTOM as const,
  component: CapacityCustomContent,
  menuLabel: "CAPACITY_TITLE_SETUP",
  path: "capacite-custom",
  label: "CAPACITY_TITLE_SETUP",
  includedCustomers: ["cpgscom"],
};
